/* Vazzari rails: lime top line (under the header) + side rails with tiny "THINK · ACT · DISRUPT" text.
   Text offset is tied to scroll position (down = one way, up = the other); a blurred ghost copy lags behind for a light trail.
   Transform-only, rAF-throttled, passive scroll listener, pointer-events none. Static when prefers-reduced-motion. */
(function(){
  if (window.__vzRails) return; window.__vzRails = true;
  var PHRASE = 'THINK \u00b7 ACT \u00b7 DISRUPT \u00b7 ';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function build(){
    /* speed v1 (21 Oct 2026): collection pages hide the rails (html.vzcl), so do not build them there at all */
    if (document.documentElement.classList.contains('vzcl')) return;
    var text = new Array(80).join(PHRASE);
    var root = document.createElement('div'); root.className = 'vz-rails'; root.setAttribute('aria-hidden','true');
    var rails = {};
    ['t','l','r'].forEach(function(k){
      var rail = document.createElement('div'); rail.className = 'vz-rail vz-rail--' + k;
      var ghost = document.createElement('span'); ghost.className = 'vz-rail__track vz-rail__track--ghost'; ghost.textContent = text;
      var main = document.createElement('span'); main.className = 'vz-rail__track'; main.textContent = text;
      rail.appendChild(ghost); rail.appendChild(main); root.appendChild(rail);
      rails[k] = {rail:rail, main:main, ghost:ghost, g:0};
    });
    document.body.appendChild(root);
    var header = document.querySelector('header.header-section, #header-group, .header-section, header');
    var PERIOD = 1400;            /* px of text before the pattern repeats (long string, so we just wrap a big window) */
    var target = 0, raf = 0, lastTop = -1, lastEvt = 0;
    function headerBottom(){
      if (!header) return 0;
      var b = header.getBoundingClientRect().bottom;
      return b > 0 ? Math.round(b) : 0;
    }
    function apply(k, v, isX){
      var r = rails[k]; var m = ((v % PERIOD) + PERIOD) % PERIOD;
      /* ghost eases toward the main offset -> brief trail behind the motion */
      r.g += (m - r.g) * 0.18; if (Math.abs(m - r.g) > PERIOD/2) r.g = m;
      var t1 = isX ? 'translate3d(' + (-m) + 'px,0,0)' : 'translate3d(0,' + (-m) + 'px,0)';
      var t2 = isX ? 'translate3d(' + (-r.g) + 'px,0,0)' : 'translate3d(0,' + (-r.g) + 'px,0)';
      r.main.style.transform = t1; r.ghost.style.transform = t2;
      return Math.abs(m - r.g) > 0.4;
    }
    function frame(){
      raf = 0;
      var top = headerBottom();
      if (top !== lastTop){ rails.t.rail.style.setProperty('--vz-top', top + 'px'); lastTop = top; }
      if (reduce) { if (performance.now() - lastEvt < 700) raf = requestAnimationFrame(frame); return; }
      var y = target * 0.6;
      var moving = apply('t', y, true) | apply('l', y + 400, false) | apply('r', -y + 400, false);
      if (moving || performance.now() - lastEvt < 700) raf = requestAnimationFrame(frame);   /* ease the trail + follow the sticky header's slide, then stop (no idle loop) */
    }
    function onScroll(){ lastEvt = performance.now(); target = window.scrollY || window.pageYOffset || 0; if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
/* Footer: split "BRAND // plain" link labels into styled spans; make sure each heading has one lime "//". Text is not changed. */
(function(){
  function split(){
    document.querySelectorAll('footer .footer-content .menu__item a').forEach(function(a){
      if (a.dataset.vzSplit) return;
      var walker=document.createTreeWalker(a,NodeFilter.SHOW_TEXT,null), n, hit=null;
      while((n=walker.nextNode())){ if(n.nodeValue.indexOf(' // ')>-1){hit=n;break;} }
      if(!hit) return;
      var parts=hit.nodeValue.split(' // '); var brand=parts.shift(); var plain=parts.join(' // ');
      var f=document.createDocumentFragment();
      function sp(c,t){var s=document.createElement('span');s.className=c;s.textContent=t;return s;}
      f.appendChild(sp('vz-fl__brand',brand.trim())); f.appendChild(sp('vz-fl__sep','//')); f.appendChild(sp('vz-fl__plain',plain.trim()));
      hit.parentNode.replaceChild(f,hit); a.dataset.vzSplit='1';
    });
    document.querySelectorAll('footer .footer-content :is(.menu__heading__default,.menu__heading__accordion,.email-signup__heading)').forEach(function(h){
      if (h.dataset.vzHead) return; h.dataset.vzHead='1';
      var walker=document.createTreeWalker(h,NodeFilter.SHOW_TEXT,null), n, first=null;
      while((n=walker.nextNode())){ if(n.nodeValue.trim()){first=n;break;} }
      if(!first) return;
      var t=first.nodeValue.replace(/^\s*\/\/\s*/,'');
      var s=document.createElement('span'); s.className='vz-fh__sep'; s.textContent='//';
      first.nodeValue=t; first.parentNode.insertBefore(s,first);
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',split); else split();
})();